import { useEffect, useMemo, useRef } from "react";
import { buildSafeHtmlDocument, containsHtmlMarkup, renderContent } from "../../Utils/uiUtils";

const SafeHtmlContent = ({ content, title = "Formatted product details" }) => {
  const frameRef = useRef(null);
  const resizeObserverRef = useRef(null);
  const hasHtml = containsHtmlMarkup(content);
  const safeDocument = useMemo(
    () => hasHtml ? buildSafeHtmlDocument(content) : "",
    [content, hasHtml]
  );

  useEffect(() => () => resizeObserverRef.current?.disconnect(), []);

  const resizeFrame = () => {
    const frame = frameRef.current;
    const document = frame?.contentDocument;
    if (!frame || !document) return;

    const updateHeight = () => {
      const height = Math.max(
        document.body?.scrollHeight || 0,
        document.documentElement?.scrollHeight || 0
      );
      frame.style.height = `${Math.max(height, 80)}px`;
    };

    resizeObserverRef.current?.disconnect();
    if (typeof ResizeObserver === "function") {
      resizeObserverRef.current = new ResizeObserver(updateHeight);
      if (document.body) resizeObserverRef.current.observe(document.body);
      resizeObserverRef.current.observe(document.documentElement);
    }
    updateHeight();
  };

  if (!hasHtml) {
    return <div>{renderContent(String(content || ""))}</div>;
  }

  return (
    <iframe
      ref={frameRef}
      className="product-about-html-frame"
      title={title}
      sandbox="allow-same-origin allow-popups"
      srcDoc={safeDocument}
      onLoad={resizeFrame}
    />
  );
};

export default SafeHtmlContent;
